import LockedThumbnail from './LockedThumbnail';

export default LockedThumbnail;
